import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Loader } from '@calendly/ui/components/loader';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { seatRequestBannerOpenedFromSelector } from './selectors';
import { setToSubmitStep } from './slice';
import { TRACKING_EVENT_NAMES, useTrack } from '../../hooks/analytics_events';
const orgListTitleCss = "o70ei4t";
const OrgListTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h3';
  return <Component ref={ref} {...restProps} className={classNames(orgListTitleCss, props.className)} />;
});
const orgListItemsCss = "o1xq0hq1";
const OrgListItems = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(orgListItemsCss, props.className)} />;
});
const orgListItemWrapperCss = "o29zioz";
const OrgListItemWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(orgListItemWrapperCss, props.className)} />;
});
const OrgListItem = ({
  ownerName,
  userCount,
  onClick,
  disableButton,
  previouslyDeclined
}) => <OrgListItemWrapper>
    <div>
      <div>
        <BodyText size="large">
          {I18n.t('publisher.growth_experiments.seat_requests.request_modal.org_list.org_owner_name', {
          name: ownerName
        })}
        </BodyText>
      </div>

      <div>
        <BodyText color={colorTextSecondary}>
          {I18n.t('publisher.growth_experiments.seat_requests.request_modal.org_list.org_seat_count', {
          count: userCount
        })}
        </BodyText>
      </div>
    </div>

    <div>
      {previouslyDeclined ? <Button decoration="secondary-outline" disabled size="small">
            {I18n.t('publisher.growth_experiments.seat_requests.request_modal.request_declined').toUpperCase()}
          </Button> : <Button decoration="secondary-outline" disabled={disableButton} onClick={onClick}>
              {I18n.t('publisher.growth_experiments.seat_requests.request_modal.request_to_join')}
            </Button>}
    </div>
  </OrgListItemWrapper>;
export const OrgList = ({
  loading,
  collection
}) => {
  const dispatch = useDispatch();
  const openedFrom = useSelector(seatRequestBannerOpenedFromSelector);
  const track = useTrack();
  return <>
      <OrgListTitle>
        {I18n.t('publisher.growth_experiments.seat_requests.request_modal.org_list.title')}
      </OrgListTitle>

      {loading ? <Loader size="small" /> : <OrgListItems>
          {collection?.map(org => <OrgListItem key={org.orgUuid} ownerName={org.ownerName} onClick={() => {
        track({
          name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
          properties: {
            action: 'opening',
            modal_name: 'connect_with_existing_org',
            modal_details: 'send_an_email_request',
            location: openedFrom,
            path: window.location.pathname
          }
        });
        dispatch(setToSubmitStep(org));
      }} previouslyDeclined={org.previouslyDeclined} userCount={org.activeSeatCount} />)}
        </OrgListItems>}
    </>;
};

require("./org_list.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./org_list.js");